import { render, staticRenderFns } from "./CCSynergy.vue?vue&type=template&id=570ca78c&"
import script from "./CCSynergy.vue?vue&type=script&lang=ts&"
export * from "./CCSynergy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports